import { cn } from "@omni/utils/styles";
import { isEmpty } from "lodash-es";

import { STORE_FILTERS } from "../../storePicker.config";
import { useStorePickerContext } from "../../storePicker.context";
import { StorePickerFilter } from "../../types/storePickerFilter.enum";
import { StorePickerFilterComponent } from "./components/storePickerFilter/storePickerFilter.component";

type Props = {
    className?: string;
};

export const StorePickerFilters = ({ className }: Props) => {
    const { activeFilters, toggleFilter, config } = useStorePickerContext();

    const filters = STORE_FILTERS.filter(
        (storeFilter) =>
            config.displayStockLevel ||
            storeFilter !== StorePickerFilter.FILTER_EMPTY_STOCK
    );

    if (isEmpty(filters)) return null;

    return (
        <section
            className={cn("tw:flex tw:max-h-full tw:overflow-auto", className)}
        >
            <ul className={cn("tw:p-0 tw:m-0 tw:flex tw:flex-wrap tw:gap-2")}>
                {filters.map((storeFilter) => (
                    <StorePickerFilterComponent
                        key={storeFilter}
                        storeFeature={storeFilter}
                        active={activeFilters.includes(storeFilter)}
                        onToggle={toggleFilter}
                    />
                ))}
            </ul>
        </section>
    );
};
